/** Картинки из вставленного HTML: чужие `<img>` (Word с `file:///`, сайты с хотлинком) в статью не
 *  попадают, их адреса не наши. HTML из самого редактора (`data-pm-slice`) — копия внутри статьи,
 *  там картинки свои, их оставляем. */
export const stripPastedImages = (html: string): { html: string; removed: number } => {
  const doc = new DOMParser().parseFromString(html, 'text/html')
  if (doc.body.querySelector('[data-pm-slice]')) return { html, removed: 0 }
  const images = doc.body.querySelectorAll('img, picture')
  if (images.length === 0) return { html, removed: 0 }
  // `<picture>` уносит свои `<img>` с собой: считаем картинки по месту, а не по тегам.
  const removed = Array.from(images).filter(
    (el) => el.tagName === 'IMG' || el.querySelector('img') === null,
  ).length
  images.forEach((el) => el.remove())
  return { html: doc.body.innerHTML, removed }
}
